import React from 'react';
import { useVersionCheck } from '../hooks/useVersionCheck';

export const UpdateBanner: React.FC = () => {
    const updateAvailable = useVersionCheck();

    if (!updateAvailable) return null;

    return (
        <div className="fixed bottom-4 left-1/2 -translate-x-1/2 z-[9999] bg-white border border-gray-200 rounded-xl shadow-lg px-4 py-3 flex items-center gap-3">
            <p className="text-sm text-gray-700">A new version of the app is available.</p>
            <button
                onClick={() => window.location.reload()}
                className="bg-black text-white font-semibold px-4 py-1.5 rounded-lg text-sm hover:bg-gray-900 transition-colors"
            >
                Refresh
            </button>
        </div>
    );
};
